import React from 'react'

type RippleBackgroundProps = {
  circles?: number
  baseSizePx?: number
  gapPx?: number
  delayStepSec?: number
  borderClassName?: string
  anchorToParentCenter?: boolean
}

// Renders concentric animated circles perfectly centered in the screen
export const RippleBackground: React.FC<RippleBackgroundProps> = ({
  circles = 5,
  baseSizePx = 100,
  gapPx = 80,
  delayStepSec = 0.6,
  borderClassName = 'border-white/30',
  anchorToParentCenter = false,
}) => {
  return (
    <div
      className={anchorToParentCenter ? 'absolute' : 'absolute inset-0 flex items-center justify-center'}
      style={anchorToParentCenter ? { top: '50%', left: '50%', transform: 'translate(-50%, -50%)' } : undefined}
    >
      {Array.from({ length: circles }).map((_, i) => {
        const size = baseSizePx + i * gapPx
        return (
          <div
            key={i}
            className={`absolute rounded-full border ${borderClassName} animate-circlePulse`}
            style={{
              width: `${size}px`,
              height: `${size}px`,
              animationDelay: `${i * delayStepSec}s`,
              animationIterationCount: 'infinite',
              top: anchorToParentCenter ? '0' : '50%',
              left: anchorToParentCenter ? '0' : '50%',
              marginTop: `-${size / 2}px`,
              marginLeft: `-${size / 2}px`,
            }}
          />
        )
      })}
    </div>
  )
}

export default RippleBackground


